import React, { useMemo, useEffect, useState } from 'react'
import { Wrapper, BarStrip, ProgressBar, ModalComponent, StepperItem } from '../_components'
import Table from '../_components/Table'
import data from '../fixtures'
import Axios from 'axios'
import moment from 'moment'
import { useDispatch, useSelector } from 'react-redux'
import { setAuditModal } from '../_slices/AppSlice'

const steps = [ "Pending", "Actioned" ]

const ActionField = ( record ) => {
  const handleClick = async id => {
    await localStorage.setItem( "applicationId", id )
    await localStorage.setItem( "link", "display")
    window.location.reload()
  }

  return (
    record.row.original.verify_status?.toLowerCase() !== "completed" && 
    (<div onClick={() => handleClick( record.value )} className="uppercase cursor-pointer bg-green-700 text-xs text-center px-2 py-1 rounded text-white">
      {record.row.original.scheduled_action === "DATE_CONFIRMED" ? "Manage Audit Report" : "Schedule Audit"}
    </div> )
  )
}

const ProgressField = record => {
    return (
      <div className="flex w-full items-center justify-center">
        <ProgressBar value={record.value}/>
        <div className="text-xs mx-2">
            {`${record.value}%`}
        </div>
      </div>
    )
}


export default function AllAuditList( { product } ) {
  const AuditColumns = useMemo( () => [
    {
      Header: "#",
      accessor: "recordId"
    },
    {
      Header: "Registered Name of Applicant",
      accessor: "applicant"
    },
    {
      Header: "Email Address",
      accessor: "email_address"
    },
    {
      Header: "Annual Gross Income(UGX)",
      accessor: "annual_income"
    },
    {
      Header: "Scheduled Date",
      accessor: "scheduled_date"
    },
    {
      Header: "Scheduled Action",
      accessor: "scheduled_action"
    },
    {
     Header: "Action",
     accessor: "id",
     Cell: ActionField
    }
   
  ] )
  const dispatch = useDispatch()
  const state = useSelector( state => { 
    return {
        // displayModal: state.application.auditAdminModal?.display,
        // id: state.application.auditAdminModal?.id,
        // email: state.application.auditAdminModal?.email
        auditFlag: state.application.auditModal?.auditFlag,
        title: state.application.auditModal?.title,
    }
  })
  
  const [ records, setRecords ] = useState( [] )
  const [ loading, setLoading ] = useState( true )
  const [ tag, setTag ] = useState( "Pending" )

  useEffect( () => {
    if( loading ) {
        fetchApplications()
    }
  },[ loading ])

  const fetchApplications = async () => {
    try {
      const response = await Axios.get( process.env.REACT_APP_API_URL+`/api/auth/itcoapplication` ) 
      if( response.data ) {
       const results = response.data.map( ( result, index ) => {
        return {
            recordId: `${index+1}`,
            progress: result.progress,
            stage: result.stage,
            applicant: result.trading_name,
            email_address: result.created_by,
            date: moment( result.created_at ).format( "DD MMM, YYYY" ),
            scheduled_action: result.scheduled_action,
            scheduled_date: result.scheduled_date ? moment( result.scheduled_date) .format( "DD MMM, YYYY HH:MM" ) : "",
            annual_income: result.annual_turnover,

            id: result.id
        }
       } ).filter( record => parseInt( record.stage ) === 2 )

       setRecords( results )
       setLoading( false )
      }
    } catch (error) {
      alert( "Server error occured." )
      setLoading( false )
    }
  }

  const handleSchedule = async () => {
    let payload = JSON.parse( localStorage.getItem( "auditPayload" ))

    //schedule a meeting
    if(  payload?.scheduled_action === "" ) {
      try {
        const response = await Axios.post( process.env.REACT_APP_API_URL+`/api/auth/itcoverify`, {
          id: payload.id,
          scheduled_action: "PENDING",
          scheduled_date: moment( new Date() ).format( "DD-MMM-YYYY HH:MM" )
          // task: "Schedule_Audit",
          // comment: "Audit has been scheduled",
          // created_by: localStorage.getItem( "email" ),
          // email_address: state.email
        } )
        if( response.data ) {
          dispatch( setAuditModal( { auditFlag: false, title: "" } ) )
          alert( response.data.message )
          return window.location.reload()
        }
      } catch (error) {}
    }

    //date confirmed
    // if(  payload?.scheduled_action === "DATE_CONFIRMED" ) { 
    //   try {
    //     const response = await Axios.post( process.env.REACT_APP_API_URL+`/api/auth/itcoverify`, {
    //       id: payload.id,
    //       scheduled_action: "COMPLETED",
    //       progress: parseInt( payload.progress ) + 20,
    //       stage: parseInt( payload.stage ) + 1
    //     } )
    //     if( response.data ) {
    //       dispatch( setAuditModal( { auditFlag: false, title: "" } ) )
    //       alert( response.data.message )
    //       return window.location.reload()
    //     }
    //   } catch (error) {}
    // }
    
  }

  const handleAuditAction = async () => {}

  let payload = JSON.parse( localStorage.getItem( "auditPayload" ))

  return (
    <Wrapper>
        <div className="flex flex-col h-full">
          <BarStrip />
          <div className="flex-grow flex flex-col bg-gray-100 my-2 px-5">
            <div className="px-5 py-2 text-sm bg-white">
              {`Audit List Under Process of IT Service Provider`}
            </div>
            <div className="flex flex-col items-start justify-center w-full bg-white">
              <div className="w-full flex flex-row border-b border-gray-500 rounded-sm">
                {/* tabs */}
                {steps.map( ( item, index ) => {
                  return (
                  <StepperItem 
                    edge={index === 0} 
                    active={tag.toUpperCase() === item?.toUpperCase()} 
                    key={item} 
                    label={item} 
                    onPress={() => {
                      return setTag( item )
                    } } />
                  )
                } )}
              </div>
              <Table 
                label="Application Details"
                columns={AuditColumns}
                data={records}
              />
            </div>
          </div>
        </div>
        <ModalComponent title={state.title} open={state.auditFlag} handleOpen={() => dispatch( setAuditModal( { auditFlag: false, title: "" } ) )}>
          {/* <div className="cursor-pointer" >Close</div> */}
          <div className="grid grid-cols-1 w-[700px]">
            
            {payload?.scheduled_action === "" && 
              (<div>
                {`Add a form for the dates`}
              </div> ) }
            
              {payload?.scheduled_action === "DATE_CONFIRMED" && 
              (<div>
                {`Meeting done - Now Add Report`}
              </div> ) }
            
            <div className="flex items-center">
              <button onClick={() => dispatch( setAuditModal( { auditFlag: false, title: "" } ) )} className="bg-blue-700 w-20 text-white text-xs my-2 px-2 py-1 mx-2" type="button">
                {`Cancel`}
              </button>
              <button onClick={handleSchedule} className="bg-green-700 w-20 text-white text-xs my-2 px-2 py-1" type="button">
                {`Submit`}
              </button>
            </div>
          </div>
        </ModalComponent>
    </Wrapper>
  )
}
